import { put, select, takeLatest } from 'redux-saga/effects';
import requestWrapper from 'utils/requestWrapper';
import history from 'utils/history';
import { LOAD_HOME, CHANGE_HOME, DELETE_HOME } from './constants';

import {
  loadHomeError,
  loadHomeSuccess,
  changeHomeError,
  changeHomeSuccess,
  deleteHomeSuccess,
  deleteHomeError,
} from './actions';

import { selectHomeDomain, selectHomeData } from './selectors';

import { Button, notification, Divider, Space } from 'antd';

export function* loadHome() {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));

    // we get the campaigns linked to the home
    const homeList = yield requestWrapper('GET', `home/`, '', currentUser.token);

    if (!homeList) {
      yield put(loadHomeSuccess(false));
    } else {
      yield put(loadHomeSuccess(homeList));
    }
  } catch (error) {
    yield put(loadHomeError(error));
  }
}

export function* changeHome(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { homeData } = action;

    let changedHome = false,
      isNew = !homeData.hasOwnProperty('_id');

    if (homeData._id === undefined) {
      changedHome = yield requestWrapper('POST', 'home/new/', homeData, currentUser.token);
      notification.success({ message: 'Created' });
    } else {
      changedHome = yield requestWrapper('PATCH', 'home/', homeData, currentUser.token);
      notification.success({ message: 'Updated' });
    }

    if (!changedHome) {
      yield put(changeHomeSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (isNew) {
        //history.push({ pathname: `/home/`+homeData._id });
      }
      yield put(changeHomeSuccess(changedHome));
    }
  } catch (error) {
    yield put(changeHomeError(error));
  }
}

export function* deleteHome(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield JSON.parse(localStorage.getItem('schoolinked_user'));
    const { id } = action;

    const deleteHome = yield requestWrapper(
      'PATCH',
      `home/remove`,
      {
        _id: id,
        active: false,
      },
      currentUser.token,
    );

    if (deleteHome) {
      yield put(deleteHomeSuccess());
    }
  } catch (error) {
    yield put(deleteHomeError(error));
  }
}

export default function* homeSaga() {
  yield takeLatest(LOAD_HOME, loadHome);
  yield takeLatest(CHANGE_HOME, changeHome);
  yield takeLatest(DELETE_HOME, deleteHome);
}
